import { CountUp } from "countup.js";

const options = {
  separator: '',
  enableScrollSpy: true
};
const countUps = document.querySelectorAll('.count-up-value h3');
countUps.forEach((countUp) => {
  const value = parseInt(countUp.getAttribute('data-value') as string);
  const countUpValue = new CountUp(countUp as HTMLElement, value, options );
  countUpValue.start();
});